const lavenderField = {
    id: "lavender-field",
    name: "Lavender Field",
    ornament: "floral",
    radius: "round",
    fonts: {
        display: "Cormorant Garamond",
        heading: "Fraunces",
        body: "Newsreader",
    },
    colors: {
        bg: "#f6f3fb",
        bgAlt: "#ece6f6",
        surface: "rgba(255,252,254,0.92)",
        primary: "#4c3d66",
        primaryHover: "#3c3054",
        accent: "#b7a0d6",
        accentSoft: "#e6dcf4",
        rose: "#e4d4f2",
        roseDeep: "#c9b0e0",
        leaf: "#7d8f78",
        text: "#2d2640",
        textMuted: "#655c78",
        border: "#ddd2ee",
        buttonText: "#f8f6fb",
    },
};

const monochromeInk = {
    id: "monochrome-ink",
    name: "Monochrome Ink",
    ornament: "none",
    radius: "sharp",
    fonts: {
        display: "EB Garamond",
        heading: "EB Garamond",
        body: "Libre Baskerville",
    },
    colors: {
        bg: "#f7f5f2",
        bgAlt: "#efedea",
        surface: "#fff",
        primary: "#161616",
        primaryHover: "#000000",
        accent: "#161616",
        accentSoft: "#e4e1dc",
        rose: "#161616",
        roseDeep: "#161616",
        leaf: "#161616",
        text: "#161616",
        textMuted: "#5c5c5c",
        border: "#161616",
        buttonText: "#f7f5f2",
    },
};

const rubyBanquet = {
    id: "ruby-banquet",
    name: "Ruby Banquet",
    ornament: "floral",
    radius: "soft",
    fonts: {
        display: "Great Vibes",
        heading: "Cinzel",
        body: "Libre Baskerville",
    },
    colors: {
        bg: "#f8f1ef",
        bgAlt: "#f1e4e0",
        surface: "rgba(255,248,246,0.92)",
        primary: "#6e1d2c",
        primaryHover: "#541520",
        accent: "#a24b55",
        accentSoft: "#f0d2cc",
        rose: "#e7b7b0",
        roseDeep: "#c48178",
        leaf: "#6e4038",
        text: "#2a1418",
        textMuted: "#6e4e54",
        border: "#e4cdc8",
        buttonText: "#fbf6f5",
    },
};

const moroccanLantern = {
    id: "moroccan-lantern",
    name: "Moroccan Lantern",
    ornament: "arch",
    radius: "soft",
    fonts: {
        display: "Italiana",
        heading: "Cinzel",
        body: "EB Garamond",
    },
    colors: {
        bg: "#f6efe4",
        bgAlt: "#efe3d2",
        surface: "rgba(255,248,238,0.92)",
        primary: "#1c2c6b",
        primaryHover: "#141f4d",
        accent: "#e2a12b",
        accentSoft: "#f6ddb0",
        rose: "#c45c26",
        roseDeep: "#9a4218",
        leaf: "#1c2c6b",
        text: "#1a1a1a",
        textMuted: "#5e564c",
        border: "#e0c48a",
        buttonText: "#f6efe4",
    },
};

const colorStories = [lavenderField, monochromeInk, rubyBanquet, moroccanLantern];

export default colorStories;
